import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';

import api from './../services/api'
import { defaultHeaders } from './../services/auth'
import CONFIG_SPM from './modals/spm'

import { startOfMonth, endOfMonth, format, getDate } from 'date-fns'
import Swal from 'sweetalert2'

export default function SPM(props) {
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [startDate, setStartDate] = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'))
    const [endDate, setEndDate] = useState(format(endOfMonth(new Date()), 'yyyy-MM-dd'))
    const [rows, setRows] = useState([])

    const paginationComponentOptions = {
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const customStyles = {
        headCells: {
            style: {
                background: '#63A8EB ',
                color: "#fff",
                minHeight: "35px",
                height: "35px",
            },
        },
        rows: {
            style: {
                minHeight: "40",
                height: "40px",
            },
        },
        pagination: {
            style: {
                justifyContent: 'flex-start'
            }
        }
    };

    const handleButtonClick = (row) => {
        var link = document.createElement("a");
        link.download = 'SMP';
        link.href = row.URL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleDeleteClick = (row) => {
        Swal.fire({
            title: 'Confirmação de Exclusão?',
            text: "Deseja realmente excluir o registro selecionado?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            customClass: {
                confirmButton: 'btn-size',
                cancelButton: 'btn-size'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                await api.delete('/os/deletarRelatorioSpm/' + row.ID, { headers: defaultHeaders() })
                    .then(response => {
                        if (response.status === 200) {
                            getData()
                            Swal.fire({
                                title: 'Sucesso!',
                                text: response.message,
                                confirmButtonColor: "#63A8EB",
                                icon: 'success',
                                confirmButtonText: 'OK'
                            })
                        } else
                            Swal.fire({
                                title: 'Erro!',
                                text: response.message,
                                confirmButtonColor: "#63A8EB",
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        })
    }

    const getData = async () => {
        setLoading(true)
        await api.post('/os/buscarRelatoriosSpm', { headers: defaultHeaders() }, {
            dt_ini: startDate,
            dt_fin: endDate
        })
            .then(response => {
                if (!response.data.message)
                    setRows(response.data || [])
                else
                    setRows([])
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }

    useEffect(() => {
        getData()
    }, [])


    const columns = [
        {
            name: 'ID',
            selector: row => row.ID,
            sortable: true,
            style: {
                maxWidth: '100px'
            },
        },
        {
            name: 'Data Geração',
            selector: row => format(new Date(row.DATA_CADASTRO), 'dd/MM/yyyy'),
            sortable: true,
            style: {
                maxWidth: '120px'
            }
        },
        {
            name: 'Data Inicial',
            selector: row => row.DATA_INI !== null && format(new Date(row.DATA_INI), 'dd/MM/yyyy'),
            sortable: true,
            style: {
                maxWidth: '120px'
            }
        },
        {
            name: 'Data Final',
            selector: row => row.DATA_FIN !== null && format(new Date(row.DATA_FIN), 'dd/MM/yyyy'),
            sortable: true,
            style: {
                maxWidth: '120px'
            }
        },
        {
            name: 'N° Série',
            selector: row => row.SERIE,
            sortable: true,
            style: {
                maxWidth: '160px'
            }
        },
        {
            name: 'Equipamento',
            selector: row => row.EQUIPAMENTO,
            sortable: true,
            style: {
                minWidth: '200px'
            }
        },

        {

            cell: (row) => <button title="Baixar PDF do relatório" onClick={e => handleButtonClick(row)} className="btn btn-primary"><i className='fa fa-download' /></button>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            style: {
                minWidth: '45px'
            }
        },
        {

            cell: (row) => <button title="Excluir o relatório" onClick={e => handleDeleteClick(row)} className="btn btn-danger"><i className='fa fa-ban' /></button>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            style: {
                minWidth: '45px'
            }
        }
    ];

    const handleShowModal = () => {
        setShowModal(false)
    }

    return (
        <>
            <CONFIG_SPM showModal={showModal} handleCloseModal={handleShowModal} />
            <div className='margim-modal'>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <button className="btn btn-primary btn-position" onClick={e => setShowModal(true)} title="Gerar novo relatório"><i className="fa fa-chart-line" /> Novo</button>
                    </div>
                    <div style={{ display: "flex", marginLeft: "10px", borderLeft: "1px dashed #cacaca", paddingLeft: "15px" }}>
                        <div>
                            <label>Inicial</label>
                            <input type="date" className='form-control' value={startDate} onChange={e => setStartDate(e.target.value)} style={{ width: "105px" }} />
                        </div>

                        <div style={{ marginLeft: "10px" }}>
                            <label>Final</label>
                            <input type="date" className='form-control' value={endDate} onChange={e => setEndDate(e.target.value)} style={{ width: "105px" }} />
                        </div>
                        <div style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
                            <button className="btn btn-success" style={{ marginTop: '25px' }} disabled={loading} onClick={e => getData()} title="Filtrar por período selecionado">{loading ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-filter" />}</button>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "15px" }}>
                    <DataTable
                        columns={columns}
                        data={rows}
                        pagination
                        customStyles={customStyles}
                        striped
                        noDataComponent="Nenhum relatório a ser exibido"
                        paginationComponentOptions={paginationComponentOptions}
                    />
                </div>
            </div>
        </>
    )
}